import { List } from '@mui/material';
import update from 'immutability-helper';
import * as React from 'react';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ReorderListItem from './ReorderListItem';


//////////////////////////////////////////////////////////////////////////////////

export interface IListData {
    id: string | number;
    content: string | React.ReactNode;
}

interface IProps {
    items: IListData[];
    className?: string;
    onClick?: (item: IListData) => void;
    onMoveListItem?: (items: (string | number)[]) => void;
}

interface IState {
    items: IListData[];
}

//////////////////////////////////////////////////////////////////////////////////

class ReorderListComponent extends React.PureComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            items: props.items && props.items.map((item) => { return { id: item.id, content: item.content } })
        };
    }


    moveListItem(dragIndex: number, hoverIndex: number) {
        const { items } = this.state;
        const dragitem = items[dragIndex];

        this.setState(
            update(this.state, {
                items: {
                    $splice: [[dragIndex, 1], [hoverIndex, 0, dragitem]],
                },
            }),
        );

        if (this.props.onMoveListItem)
            this.props.onMoveListItem(this.state.items.map((v) => v.id));
    }

    render() {
        const { items } = this.state;
        const { className, onClick } = this.props;

        return (
            <DndProvider backend={HTML5Backend} >
                <div>
                    <List>
                        {items.map((item, i) => (
                            <ReorderListItem
                                key={item.id}
                                index={i}
                                id={item.id}
                                className={className}
                                content={item.content}
                                onClick={() => onClick(item)}
                                onMoveListItem={(dragIndex, hoverIndex) => this.moveListItem(dragIndex, hoverIndex)}
                            />
                        ))}
                    </List>
                </div>
            </DndProvider>
        );
    }
}


export default ReorderListComponent;